import React from 'react'

import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import styled from '@emotion/styled'

import { Button, ModalHead, ModalBody, ModalFoot } from 'mailup-web-components'

import {
  validStep2State,
  modalBeeContentDialogContentsState
} from '../recoil/state'
import { modalContentDialogConfirmCallback } from '../recoil/callbacks'

import SearchContentsForm from './SearchContentsForm'
import SearchContentsResults from './SearchContentsResults'
import SearchContentsPagination from './SearchContentsPagination'

import ContentsPreview from './ContentsPreview'

import PreviewIndicator from './PreviewIndicator'

import ErrorFeedback from './ErrorFeedback'

import BackButton from './BackButton'

const StyledContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const StyledSearchPanel = styled.div`
  flex: 0 0 67%;
  max-width: 67%;
  padding: 20px 30px 55px 30px;
  border-right: 1px solid var(--geyser);
`

const StyledPreviewPanel = styled.div`
  flex: 0 0 33%;
  max-width: 33%;
  display: flex;
  flex-direction: column;

  overflow: hidden;
`

const ContentsConfig = () => {
  const intl = useIntl()

  const validStep2 = useRecoilValue(validStep2State)

  const handleConfirm = useRecoilCallback(modalContentDialogConfirmCallback, [])

  const { error, severity } = useRecoilValue(modalBeeContentDialogContentsState)

  return (
    <>
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.BeeContentDialog.FilterAndSelectContents'
        })}
      >
        <BackButton />
      </ModalHead>
      {error ? (
        <ErrorFeedback error={error} severity={severity} />
      ) : (
        <>
          <ModalBody>
            <StyledContainer>
              <StyledSearchPanel>
                <SearchContentsForm />
                <SearchContentsResults />
                <SearchContentsPagination />
              </StyledSearchPanel>
              <StyledPreviewPanel>
                <PreviewIndicator />
                <ContentsPreview />
              </StyledPreviewPanel>
            </StyledContainer>
          </ModalBody>
          <ModalFoot>
            <Button
              kind='primary'
              onClick={handleConfirm}
              disabled={!validStep2}
            >
              {intl.formatMessage({
                id: 'Load.BeeContentDialog.InsertContents'
              })}
            </Button>
          </ModalFoot>
        </>
      )}
    </>
  )
}

export default ContentsConfig
